// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2HgVI","label":"CategoryService_label__2Lfh3","location":"CategoryService_location__1ZT2X"};